export default "__VITE_ASSET__79c1da01__"